import { createStore } from 'vuex'
import cart from './modules/cart'
import customer from './modules/customer'
import debrisTypes from './modules/debrisTypes'
import dumpster from './modules/dumpster'
import lockRate from './modules/lockRate'
import onPoint from './modules/onPoint'
import project from './modules/project'
import ui from './modules/ui'

// All state should be stored in namespaced modules
export default createStore({
  modules: {
    cart,
    customer,
    debrisTypes,
    dumpster,
    lockRate,
    onPoint,
    project,
    ui
  }
})
